export enum SortTypes {
  AVG_SPEED = 'vavg',
  MAX_SPEED = 'maxSpeed',
  PARK_TIME = 'ptime',
  DISTANCE = 'dist',
  RIDE_TIME = 'rtime',
  ENGINE_STARTS = 'stops',
}

export enum AlphabeticSortTypes {
  ASC = 'asc',
  DESC = 'desc',
}
export interface SortData {
  sort?: SortTypes;
  showSort?: boolean;
  alphabeticSort?: AlphabeticSortTypes;
}
